module.exports = __webpack_public_path__ + "img/test03-5.b4b00bc3.jpg";